// Per-studio branding for public-facing pages (share + client gallery).
// Adding a new studio: add a new entry keyed by account_key.
// Later, `logo_url` can be swapped in for the `mark` when real image files are ready.
export const BRANDS = {
  witty_shadows: {
    name: "Wittyshadows",
    tagline: "File Transfer",
    mark: "W",
    accent: "#F5A623",       // amber
    accentText: "#000000",   // text ON accent bg
    accentSoft: "rgba(245,166,35,0.1)",
    accentBorder: "rgba(245,166,35,0.4)",
    footerLine: "Powered by Wittyshadows",
  },
  trio_bliss: {
    name: "Trio Bliss Photography",
    tagline: "File Transfer",
    mark: "TB",
    accent: "#14B8A6",       // teal (distinct from amber)
    accentText: "#FFFFFF",   // white on teal
    accentSoft: "rgba(20,184,166,0.1)",
    accentBorder: "rgba(20,184,166,0.4)",
    footerLine: "Powered by Trio Bliss Photography",
  },
};

// Fallback used when account_key is missing / unknown / local.
const DEFAULT_BRAND = BRANDS.witty_shadows;

export const brandFor = (accountKey) => BRANDS[accountKey] || DEFAULT_BRAND;
